export type GridSector = 'salon' | 'patio';

export interface SectorGrid {
  cols: number;
  rows: number;
  originX: number;
  originZ: number;
  cell: number;
}

export const SALON_GRID: SectorGrid = { cols: 9, rows: 7, originX: -15.5, originZ: -3.5, cell: 1.75 };
export const PATIO_GRID: SectorGrid = { cols: 7, rows: 6, originX: 5.5, originZ: -3.5, cell: 1.85 };

export function gridMeta(sector: GridSector): SectorGrid {
  return sector === 'salon' ? SALON_GRID : PATIO_GRID;
}

export function gridCellToWorld(
  sector: GridSector,
  col: number,
  row: number,
  cols: number,
  rows: number,
): { worldX: number; worldZ: number } {
  const g = gridMeta(sector);
  const cx = col + cols / 2;
  const cz = row + rows / 2;
  return { worldX: g.originX + cx * g.cell, worldZ: g.originZ + cz * g.cell };
}

export function worldToGridCell(
  sector: GridSector,
  worldX: number,
  worldZ: number,
  footprintCols: number,
  footprintRows: number,
): { col: number; row: number } {
  const g = gridMeta(sector);
  const col = Math.round((worldX - g.originX) / g.cell - footprintCols / 2);
  const row = Math.round((worldZ - g.originZ) / g.cell - footprintRows / 2);
  return { col, row };
}

export function cellInBounds(sector: GridSector, col: number, row: number, cols: number, rows: number): boolean {
  const g = gridMeta(sector);
  return col >= 0 && row >= 0 && col + cols <= g.cols && row + rows <= g.rows;
}
